import React from 'react'
import PropTypes from 'prop-types'
import {
  BookingBannerContent,
  BookingBannerImageWrapper,
  BookingBannerMain,
} from './index.style'
import { GatsbyImage } from 'gatsby-plugin-image'
import Container from '../Container'
import Spacer from '../Spacer'
import RichText from '../RichText'
import AnimateScaleIn from '../animation/AnimateScaleIn'
import AnimateSlideIn from '../animation/AnimateSlideIn'
import Button from '../Button'
import { colors } from '../../styles/vars/colors.style'
import ScrollSection from '../ScrollSection'

const BookingBanner = ({ id, title, ctaText, ctaUrl, background, gallery }) => {
  return (
    <ScrollSection>
      <BookingBannerMain background={background}>
        {React.Children.toArray(
          gallery.map((image, imageIndex) => (
            <BookingBannerImageWrapper>
              <AnimateScaleIn
                id={`${id}-img-${imageIndex}`}
                position="relative"
                delay={1}
              >
                <GatsbyImage
                  image={image.gatsbyImageData}
                  alt={image.description}
                  width={195}
                />
              </AnimateScaleIn>
            </BookingBannerImageWrapper>
          ))
        )}

        <Container>
          <Spacer size={136} />

          <BookingBannerContent>
            <RichText id={`${id}-text`} content={title} />

            <Spacer size={[28, 54]} />

            <AnimateSlideIn id={`${id}-btn`}>
              <Button href={ctaUrl} variant="fill" color={colors.orange}>
                {ctaText}
              </Button>
            </AnimateSlideIn>
          </BookingBannerContent>

          <Spacer size={136} />
        </Container>
      </BookingBannerMain>
    </ScrollSection>
  )
}

BookingBanner.propTypes = {
  id: PropTypes.string,
  title: PropTypes.object,
  ctaText: PropTypes.string,
  ctaUrl: PropTypes.string,
  background: PropTypes.string,
  gallery: PropTypes.array,
}

export default BookingBanner
